import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { PartidaAclaracionGuiaEdit } from "./edit";
import { PartidaAclaracionGuia, CondicionPago, DescripcionConcepto } from "app/models/requireme";
import { TotalConceptoList } from "../totales";
const EditModal = PartidaAclaracionGuiaEdit;
type Entity = models.PartidaAclaracionFacturaDTO;
export interface Props {
    value: Entity[];
    onChange: (value: Entity[]) => PromiseLike<void> | void;
    readonly?: boolean;
}

/**Obtiene las columnas del grid */
function columnas(deps: kea.BotonesListaDeps<Entity>): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [
        botones,
        { title: "Factura", cell: x => ({ data: x.Serie + "-" + x.Folio }) },
        { title: "Observaciones", cell: x => ({ data: x.Observaciones }) },
        { title: "Condición", cell: x => ({ data: x.CondicionNombre }) },
        { title: "Descripción", cell: x => ({ data: x.DescripcionNombre }) },
        { title: "Total", cell: x => ({ data: x.Total }) },
    ];
}

/**
* Listado de facturas ligadas a una partida de aclaracion
*/
class PartidasAclaracionFacturasListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    private async setValue(val: models.PartidaAclaracionFactura): Promise<models.PartidaAclaracionFacturaDTO> {
        const fac = await resources.Factura.get(val.IdFactura);
        return { ...val, Folio: fac.Folio, 
            Serie: fac.Serie, 
            CondicionNombre: val.Condicion == CondicionPago.Pagada ? "Pagada" : "Pendiente",
            DescripcionNombre: val.DescripcionConcepto == DescripcionConcepto.Devolucion ? "Devolución" : "Reexpedicion",
            Total: fac.ImporteTotal };
    }

    private handleOnAgregar = async () => {
        const result = await this.modals.showModal(EditModal, undefined, {} as Entity);;
        if (result.result) {
            const newItem = await this.setValue(result.value);
            const oldList = this.props.value;
            await this.props.onChange([...oldList, newItem]);
        }
    }


    private handleOnEditar = async (item: Entity) => {
        const result = await this.modals.showModal(EditModal, undefined, item);
        if (result.result) {
            const newItem = await this.setValue(result.value);
            const oldList = this.props.value;
            await this.props.onChange(oldList.map(x => x == item ? newItem : x));
        }
    }

    private handleOnBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?", item.Serie + "-" + item.Folio);
        if (ok) {
            const oldList = this.props.value;
            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    totales = async () => {
        const ret = await resources.PartidasAclaracion.GetTotalesFactura(this.props.value);
        return ret;
    }

    render() {
        const total = this.totales();
        const cols = columnas({ onBorrar: this.handleOnBorrar, onEdit: this.handleOnEditar });
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h4>
                            <span>Facturas asignadas</span>
                            <div className="pull-right">
                                <kea.AgregarButton onClick={this.handleOnAgregar} disabled={this.props.readonly} />
                            </div>
                        </h4>
                    </div>
                </div>
                <TotalConceptoList value={total} color="danger"/>
                <kea.Grid2 items={this.props.value} columnas={cols} />
                {this.modals.component}
            </div>
        );
    }
}
export const PartidasAclaracionFacturasList = kea.mapProps(componentToRx(PartidasAclaracionFacturasListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/partidasaclaracion/edit/facturas/list.tsx